import { Skeleton, Stack } from 'components'

interface TrackerSkeletonProps {
  readonly withSelector?: boolean
  readonly rows?: number
}

export const TrackerSkeleton = ({ withSelector = true, rows = 8 }: TrackerSkeletonProps) => (
  <Stack spacing='lg'>
    {withSelector && <Skeleton height={56} width={320} radius='sm' />}
    <Stack spacing='xs'>
      <Skeleton height={40} radius='sm' />
      {Array.from({ length: rows }).map((_, idx) => (
        <Skeleton key={idx} height={52} radius='sm' />
      ))}
    </Stack>
  </Stack>
)
